import { FormDataConsumerRenderParams } from "react-admin";
import { useEffect } from "react";
import { NotificationSubject } from "../../../common/data/service-proxies";

interface Props extends FormDataConsumerRenderParams {
  onSelectedEventsCountChanged: (count: number) => void;
  subject: NotificationSubject;
}

export const SubjectEventTypesSummaryHandler = ({
  formData,
  subject,
  onSelectedEventsCountChanged,
}: Props) => {
  useEffect(() => {
    if (!formData["eventPreferences"]) {
      onSelectedEventsCountChanged(0);
      return;
    }

    const selectedEventTypesFormData = formData["eventPreferences"][subject] as
      | Array<{ eventId: number; urgent?: boolean } | undefined>
      | undefined;
    if (!selectedEventTypesFormData) {
      onSelectedEventsCountChanged(0);
      return;
    }

    onSelectedEventsCountChanged(
      selectedEventTypesFormData.filter((x) => !!x?.eventId).length
    );
  }, [formData, onSelectedEventsCountChanged, subject]);
  return null;
};
